import { BaseModel } from './BaseModel';
import Credential from './Credential';

export class CredentialLink extends BaseModel {
  static get entity() {
    return 'credential-links';
  }

  static get fk() {
    return 'credential_link_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      credential_id: this.attr(null),
      credential: this.belongsTo(Credential, 'credential_id'),
      code: this.attr(null),
      show_evidence: this.attr(null),
      show_feedback: this.attr(null),
      show_recommendation: this.attr(null),
      expired_at: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      fetch() {
        return this.get(`/credential-links`);
      },

      fetchBadgeDetail(code, params = {}) {
        return this.get(`/credential-links/code/${code}`, params);
      },

      getCode(body = {}) {
        return this.post(`/credential-links/gen-code`, body);
      }
    }
  };
}

export default CredentialLink;
